import logo from './logo.svg';
import './App.css';
import Allroutes from './routes';

function App() {
  return (
    <Allroutes />
  );
}

export default App;
